import { createRoot } from "react-dom/client";
import { RouterProvider } from 'react-router-dom'

import { router } from "./router"
import "./index.css";

import { initSentry } from './config/sentry'
initSentry()

const rootContainer = document.getElementById("root")
const root = createRoot(rootContainer)
root.render(
  <RouterProvider router={router} />
);